import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import { DownloadTheAppProvider } from '../DownloadTheAppContext'
import MiddleWare from './MiddleWare'

const AppLoaded = ({
  children,
  clientConfig,
}: {
  children: React.ReactNode
  clientConfig: ClientModel
}) => {
  return (
    <DownloadTheAppProvider clientConfig={clientConfig}>
      <MiddleWare>{children}</MiddleWare>
    </DownloadTheAppProvider>
  )
}

export default AppLoaded
